module.exports = __webpack_public_path__ + "img/Transborder-logo.be92e345.jpeg";